/** Voice-fingerprint sample helpers shared by onboarding and settings. */

export function sampleFieldFilled(value) {
  if (value == null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  return Boolean(value);
}

export function voiceFingerprintSampleCount(samples = {}) {
  return (sampleFieldFilled(samples.writingSamples) ? 1 : 0)
    + (sampleFieldFilled(samples.audioSampleName) ? 1 : 0)
    + (sampleFieldFilled(samples.longFormSample) ? 1 : 0);
}

export function displayAssistantName(name) {
  const clean = (name || "").trim();
  return clean || "Maya";
}

/** Swap legacy default "Maya" in server-generated copy with the configured name. */
export function personalizeAssistantText(text, assistantName) {
  if (!text || typeof text !== "string") return text || "";
  const name = displayAssistantName(assistantName);
  if (name === "Maya") return text;
  return text.replace(/\bMaya\b/g, name);
}
